import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ApiService } from '../../services/api.service';

@Injectable()
export class FormSelectService {
  constructor() {}

  private _relaunch = new Subject<any>();

  state = this._relaunch.asObservable();

  relaunch() {
    this._relaunch.next()
  }
}



@Component({
  selector: 'vq-select',
  templateUrl: './form-select.component.html',
  styleUrls: []
})
export class FormSelectComponent implements OnInit, OnDestroy {

  @Input('vqModel') model:any;
  @Input('vqLabel') label:string;
  @Input('vqLabelGetter') labelGetter:any;
  @Input('vqValueGetter') valueGetter:any;
  @Input('vqDisplayLabel') displayLabel:boolean = true;
  @Input('vqOptions') options:Array<string> = [];
  @Input('vqErrors') errors:Array<string> = [];
  @Input('vqHelpText') helpText:string;
  @Input('vqApiService') apiService:any;
  @Input('vqFilter') filter:any = {};
  @Input('vqClassList') classlist:Array<string> = [];

  @Output('vqTrigger') trigger:EventEmitter<any> = new EventEmitter<any>();
  @Output('vqModelChange') modelChange:EventEmitter<any> = new EventEmitter<any>();

  id:string;
  subscription:any;

  constructor(
    private _api:ApiService,
    private _selectService: FormSelectService,
  ) { }

  ngOnInit() {
    this._getOptions();
    this.subscription = this._selectService.state.subscribe(()=>{
      this._getOptions(true);
    })
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    // console.log('destroy')
  }

  private _initModel() {
    if (this.model === undefined) {
      this.change('');
    }
  }

  private _resolveValue(obj:any, attr:string):any {
    return attr.split('.').reduce(function(prev, curr) {
        // return prev[curr] ? prev[curr] : prev;
        return prev[curr];
    }, obj)
  }

  private _isString(v) {
    return typeof v === 'string';
  }

  // private _defaultLabelGetter(o:any):any {
  //   return o;
  // }

  // private _defaultValueGetter(o:any):any {
  //   return o;
  // }

  public getLabel(a) {
    if (this._isString(this.labelGetter)) {
      return this._resolveValue(a, this.labelGetter);
    } else {
      return this.labelGetter(a);
    }
  }

  public getValue(a) {
    if (this._isString(this.valueGetter)) {
      return this._resolveValue(a, this.valueGetter);
    } else {
      return this.valueGetter(a);
    }
  }

  public change($event) {
  	this.model = $event;
  	this.modelChange.emit($event);
    this.trigger.emit($event);
  }

  count = 0;

  private _getOptions(forced:boolean = false) {
    // console.log('select options')
    if ((!this.options || (this.options && this.options.length == 0)) || forced) {
      let q = Object.assign({}, this.filter);
      // this.count++;
      q.limit = 150;
      // console.log('get options')
      // setTimeout(()=> {
      // console.log(q)
      // console.log(this.apiService)
        this._api[this.apiService].list(q).subscribe((v) => {
          this.options = v.results;
        })
      // }, 0)
    }
  }

  public hasError() {
    return (this.errors && this.errors.length > 0);
  }

}



// WEBPACK FOOTER //
// ./src/app/vqforms/form-select/form-select.component.ts